import routes from '@modules/club/club-routes';
import store from '@modules/club/club-store';

export default {
  routes,
  store,
};
